<template>
  <div id="product-browse">

    <div id="product-category-selection-wrapper" class="noto-sans-sc-font-family">

      <div id="product-category-selection" class="text-center">
        <v-menu offset-y nudge-bottom="-10px" nudge-left="13px">
          <template v-slot:activator="{ on }">
            <div
              v-on="on"
              id="category-selection-btn"
              class="category-selection d-inline-block py-4"
            >
              {{ selectedCategoryDislayLabel }}
              <v-icon color="#e2211c">keyboard_arrow_down</v-icon>
            </div>

          </template>

          <div class="text-center">
            <div 
              class="noto-sans-sc-font-family category-selection py-3 px-6"
              v-for="(category, index) in unselectedCategory"
              @click="updateCategory(category)"
              :key="index"
            >{{ category.name}}</div>
            
          </div>
        </v-menu>
      </div>

      <transition name="fade">
        <div
          id="product-subcategory-selection-wrapper"
          class="noto-sans-sc-font-family font-size-12"
          v-if="hasProductSubcategory()"
        >
          <div
            id="product-subcategory-selection"
            class="mx-auto d-flex justify-space-around flex-wrap main-content-width px-3"
          >

            <!-- 去掉 -->
            <!-- <div
              class="product-subcategory py-3 px-2 text-center"
              :class="{ 'active-subcategory' : isActiveSubcategory(subcategory) }"
              v-for="(subcategory, index) in productSubcategory"
              @click="updateSubcategory(subcategory)"
              :key="index"
            >{{ subcategory.name }}</div> -->


          </div>

        </div>
      </transition>
    </div>
            <!-- 产品分类条 -->
             <div class="product-subcategory-wrapper" >
            <div id="changpingfenleitiao"
              class="product-subcategory py-3 px-2 text-center"
              :class="{ 'active-subcategory' : isActiveSubcategory(subcategory) }"
              v-for="(subcategory, index) in productSubcategory"
              @click="updateSubcategory(subcategory)"
              :key="index"
             
            >{{ subcategory.name }}&nbsp;</div>
            </div>
    <div id="search-results-wrapper" class="main-content-width mx-auto mt-5 mb-9">
             

      <!-- 产品显示 -->
      <transition name="slide-fade" mode="out-in">
        <div v-if="hasNoSearchResult" class="text-center noto-sans-sc-font-family" key="NoResult">
          <div id="search-result-hint" class="search-hint px-2">{{ searchResultHintText }}</div>
          <div id="search-result-full-hint" class="search-hint px-2">{{ searchResultFullHintText }}</div>
        </div>
        <v-row
          v-if="hasSearchResult"
          no-gutters
          key="hasResult"
          class="px-sm-2 px-md-0 justify-space-around justify-sm-start"
        >
          <v-hover v-slot:default="{ hover }" v-for="(product, index) in products" :key="index">
            <v-col
              :class="{'elevation-5' : hover}"
              class="product-card-wrapper mt-4 ml-sm-3"
              cols="6"
              md="4"
            >
              <product-card
                :title="product.tinyTitle"
                :imageSrc="getProductImage(product.id, product.images[0])"
                :displayPrice="product.amazonListings[0].displayPrice"
                :rating="rating"
                :id="product.id"
              ></product-card>
            </v-col>
          </v-hover>
        </v-row>
      </transition>


      <!-- <div
        id="paging-wrapper"
        v-if="hasSearchResult"
        class="py-12 text-end noto-sans-sc-font-family"
      >
        <v-icon color="#666666">keyboard_arrow_left</v-icon>
        <span class="page-num pb-1">1</span>
        <v-icon color="#666666">keyboard_arrow_right</v-icon>
      </div> -->
    </div>
  </div>
</template>

<script>
import ProductCard from "../components/ProductCard";
import productBrowseMixins from "../../mixins/productBrowseMixins";


export default {
  components: {
    ProductCard
  },
  mixins: [productBrowseMixins]
};
</script>

<style scoped>
#product-browse {
  width: 100%;
}

#product-category-selection {
  border-bottom: 1px solid #e6e6e6;
  border-top: 1px solid #e6e6e6;
}

.category-selection {
  color: #333333;
  cursor: pointer;
  background-color: white;
}

.v-menu__content {
  box-shadow: none;
  border: 1px #dadada solid;
  z-index: 1 !important;
}

#product-subcategory-selection-wrapper {
  border-bottom: 1px solid #e6e6e6;
}
.product-subcategory-wrapper{
   float: left;
  width: 15em;
  margin-top: 5%;
}

.product-subcategory {
  cursor: pointer;
  color: #999999;
   float: left;
   margin-left: 12%;
   /* width: 50%; */ 
}



.product-subcategory::before {
  height: 10px;
  position: absolute;
  left: -4px;
  top: 13px;
  width: 9px;
  border-bottom: 4px solid #e2211c;
  content: "";
  opacity: 0;
}

.active-subcategory {
  transition: 1s;
  position: relative;
  color: red;
}

.product-subcategory.active-subcategory::before {
  transition: opacity 1s;
  opacity: 1;
}

#search-results-wrapper {
  position: relative;
}

.product-card-wrapper {
  height: 22em;
  max-width: 23%;
  background-color: #f6f6f7;
  border-radius: 3px;
  transition: 0.5s;
}
.product-card-wrapper:hover {
  background-color: white;
}

@media only screen and (max-width: 912px) {
  .skeleton-loader-wrapper,
  .product-card-wrapper {
    max-width: 47%;
  }
}

.skeleton-loader-wrapper {
  max-width: 32%;
}

.image-skeleton-loader {
  width: 100%;
  height: 300px;
}

#paging-wrapper {
  color: #666666;
}

.page-num {
  color: black;
  border-bottom: #adadad 2px solid;
}
    

</style>
